import {
  Field,
  NumberField,
  StringField,
} from '../../util/components/resource/resource-fields';
import { ApiResource } from '../api-resource';
import { Endpoint } from '../api.decorators';
import { PaymentHistory } from './payment-history.model';
import {
  Invoice,
  PaymentReason,
  PaymentReferences,
  PaymentStatus,
  PaymentType,
  RegistrationPayment,
} from './lib/payment.interfaces.js';
import { toTitleCase } from '../../util/string';
import { formatTableDate } from '../../util/date';
import { paymentReasonLabels } from './lib/payment.i18n';
import { Registration } from '../registration/registration.model';

@Endpoint('payments', 'Payment')
export class Payment<T extends PaymentType = PaymentType> extends ApiResource<
  Payment<T>
> {
  @NumberField({ label: $localize`Amount` })
  amount!: number;

  @StringField({ label: $localize`Bank account` })
  bankAccount!: string;

  @Field({ includeFilter: false })
  reference!: PaymentReferences[T];

  // fixme: Use discriminated type union
  @Field({ includeFilter: false })
  metadata!: {
    reason: PaymentReason;
    order: { registrations: RegistrationPayment[] };
  };

  @Field({ includeFilter: false })
  history?: PaymentHistory;

  @Field({ label: $localize`Status`, type: () => PaymentStatus })
  status!: PaymentStatus;

  @Field({ label: $localize`Type`, type: () => PaymentType })
  type!: T;

  @Field({ label: $localize`Invoice` })
  invoice?: Invoice;

  registrations?: Registration[];

  override toLabel(): string {
    return (
      toTitleCase(this.type) +
      ' ' +
      paymentReasonLabels[this.metadata.reason] +
      ' ' +
      formatTableDate(this.createdAt)
    );
  }
}
